<template>
    <div>
        <div class="row">
            <div class="col-12 col-lg-9">
                <Slogan />
            </div>
        </div>

        <div class="mt-4 article">
            <h2>Impressum</h2>
            <p><span class="u-bold">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</span><br>Nick Böcker</p>
            <p><span class="u-bold">E-Mail</span>: contact@nickhatboecker.de</p>

            <h3 class="mt-5 mb-4">Haftungsausschluss:</h3>
            <h4>Haftung für Inhalte</h4>
            <p>Die Inhalte meiner Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann ich jedoch keine Gewähr übernehmen. Als Diensteanbieter bin ich gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG bin ich als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werde ich diese Inhalte umgehend entfernen.</p>

            <h4>Haftung für Links</h4>
            <p>Meine Webseiten enthalten Links zu externen Webseiten Dritter, auf deren Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten sind stets die jeweiligen Anbieter_Innen oder Betreiber_Innen der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werde ich derartige Links umgehend entfernen.</p>

            <p>Website Impressum erstellt durch <a href="http://www.impressum-generator.de/" target="_blank" rel="noopener">impressum-generator.de</a></p>
        </div>
    </div>
</template>

<script>
import Slogan from '../components/Slogan'

export default {
    name: 'Imprint',

    components: { Slogan },
}
</script>
